import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { fmtDateTime } from "@/lib/format";
import { Loader2, Search, History } from "lucide-react";

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/audit", { params: q ? { q } : {} }); setLogs(data); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-4" data-testid="audit-page">
      <div><h1 className="font-heading text-2xl font-bold text-navy">Audit History</h1>
        <p className="text-sm text-muted-foreground">Catatan aktivitas sistem (tidak dapat diedit/dihapus).</p></div>

      <Card className="p-3">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" placeholder="Cari user, Project ID, tindakan..." className="pl-9" />
        </form>
      </Card>

      {loading ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-primary" /></div> : (
        logs.length === 0 ? <Card className="p-10 text-center text-muted-foreground"><History className="mx-auto mb-2 opacity-40" /> Belum ada catatan.</Card> : (
          <Card className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50"><tr className="text-left text-xs text-muted-foreground">
                <th className="py-2.5 px-3">Waktu</th><th className="px-3">User</th><th className="px-3">Role</th><th className="px-3">Tindakan</th>
                <th className="px-3 hidden md:table-cell">Project ID</th><th className="px-3 hidden lg:table-cell">Perubahan</th><th className="px-3 hidden lg:table-cell">Alasan</th>
              </tr></thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.id} data-testid={`audit-row-${l.id}`} className="border-t">
                    <td className="py-2 px-3 text-xs whitespace-nowrap">{fmtDateTime(l.timestamp)}</td>
                    <td className="px-3 text-xs">{l.user_name}</td>
                    <td className="px-3 text-xs">{l.role || "-"}</td>
                    <td className="px-3 text-xs font-medium">{l.action}</td>
                    <td className="px-3 text-xs font-mono-k3 hidden md:table-cell">{l.project_id || "-"}</td>
                    <td className="px-3 text-xs text-muted-foreground hidden lg:table-cell max-w-xs truncate">
                      {l.before && `Dari: ${JSON.stringify(l.before)} `}{l.after && `Ke: ${JSON.stringify(l.after)}`}
                    </td>
                    <td className="px-3 text-xs hidden lg:table-cell">{l.reason || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        )
      )}
    </div>
  );
}
